/* OBIWAN_BBQ_KLAVIYO_KILL_SWITCH_20260605: Tom requested quiz/email capture OFF due sales dive. Blocks cached old 8-sec snippets. */
(function(){
  window.__obiwanBbqKlaviyo8SecTest20260604 = true;
  window.__obiwanBbqKlaviyo8SecTestInline20260604 = true;
  window.__obiwanBbqKlaviyo8SecCarouselAsset20260604 = true;
  window.__obiwanBbqKlaviyo8SecScriptTag20260604 = true;
  var BLOCK_FORM_ID = 'Y6TJDr';
  function shouldBlock(args){
    try { return args && args[0] === 'openForm' && args[1] === BLOCK_FORM_ID; } catch(e) { return false; }
  }
  function patchQueue(q){
    if (!q || q.__obiwanBbqKlaviyoKillSwitch20260605) return q;
    var oldPush = q.push;
    q.push = function(){
      if (shouldBlock(arguments[0])) return q.length;
      return oldPush.apply(q, arguments);
    };
    q.__obiwanBbqKlaviyoKillSwitch20260605 = true;
    return q;
  }
  window._klOnsite = patchQueue(window._klOnsite || []);
})();
/* /OBIWAN_BBQ_KLAVIYO_KILL_SWITCH_20260605 */

/* OBIWAN/LUKE 20260819: Carousel->Variant color sync DISABLED. It force-reset the color radio from the active gallery image (whole-page MutationObserver), overriding the shopper's chosen color and submitting the wrong variant (e.g. Navy->Charcoal). Reverted to standard Dawn selection. Original backed up in ops/backups/bbq-theme-20260819/. */
